/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PipelineFilterSchema } from './pipelineFilterSchema';

/**
 * Body for the filtered pipeline list.
 *
 * ``stage_id`` is kept alongside ``filters.stages`` so the stage bar (a single
 * active stage) and the filter panel (multi-select) can coexist; both are
 * applied, so the bar narrows whatever the panel selected.
 */
export interface PipelineQueryRequest {
  filters?: PipelineFilterSchema | null;
  stage_id?: string | null;
  sort_by?: string | null;
  sort_order?: string | null;
  /** @minimum 1 */
  page?: number;
  /**
     * @minimum 1
     * @maximum 100
     */
  per_page?: number;
}
